import { Link } from "react-router-dom";
import "./FooterV2.scss";
import { useSelector } from "react-redux";

const WEBSITE_URL = process.env.REACT_APP_WORD_PRESS_REDIRECT_URI || "";
const WEBAPP_URL = process.env.REACT_APP_API_URL || "";

export default function FooterV2() {
  const token = useSelector((state) => state?.auth?.token);

  return (
    <footer className="footer-with-decorations">
      <div className="container py-5 position-relative" style={{ zIndex: 10 }}>
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-4">
          {/* Left: Logo and Social */}
          <div className="d-flex flex-column gap-4">
            <div>
              <img
                src="/assets/logo-footer-white.svg"
                alt="Asesso Health"
                className="footer-logo"
              />
            </div>
            <div className="d-flex gap-3">
              {/* LinkedIn */}
              <a
                href="https://linkedin.com/company/asessohealth"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Visit Asesso Health on LinkedIn"
              >
                <svg
                  className="footer-social-icon"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </a>

              {/* Facebook */}
              <a
                href="https://facebook.com/asessohealth"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Visit Asesso Health on Facebook"
              >
                <svg
                  className="footer-social-icon"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>

              {/* Instagram */}
              <a
                href="https://instagram.com/asessohealth"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Visit Asesso Health on Instagram"
              >
                <svg
                  className="footer-social-icon"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Right: Navigation */}
          <div className="row row-cols-2 row-cols-md-6 g-4 footer-nav-grid">
            {/* Solutions */}
            <div className="col">
              <h3 className="text-white fw-normal mb-3 fs-6">Solutions</h3>
              <ul className="list-unstyled footer-link-list">
                <li>
                  <Link
                    to={`${WEBSITE_URL}/solution-overview`}
                    className="footer-nav-link"
                  >
                    Solution Overview
                  </Link>
                </li>
                <li>
                  <Link
                    to={`${WEBSITE_URL}/asesso-grindguard`}
                    className="footer-nav-link"
                  >
                    GrindGuard for TMJ
                  </Link>
                </li>
                <li>
                  <Link
                    to={`${WEBSITE_URL}/sensor-module`}
                    className="footer-nav-link"
                  >
                    Sensor for Monitoring
                  </Link>
                </li>
              </ul>
            </div>

            {/* How It Works */}
            <div className="col">
              <h3 className="text-white fw-normal mb-3 fs-6">How It Works</h3>
              <ul className="list-unstyled footer-link-list">
                <li>
                  <Link
                    to={`${WEBSITE_URL}/how-it-works`}
                    className="footer-nav-link"
                  >
                    How It Works
                  </Link>
                </li>
              </ul>
            </div>

            {/* Pricing */}
            <div className="col">
              <h3 className="text-white fw-normal mb-3 fs-6">Pricing</h3>
              <ul className="list-unstyled footer-link-list">
                <li>
                  <Link
                    to={`${WEBSITE_URL}/pricing`}
                    className="footer-nav-link"
                  >
                    Pricing
                  </Link>
                </li>
              </ul>
            </div>

            {/* Our Story */}
            <div className="col">
              <h3 className="text-white fw-normal mb-3 fs-6">Our Story</h3>
              <ul className="list-unstyled footer-link-list">
                <li>
                  <Link to={`${WEBSITE_URL}/about`} className="footer-nav-link">
                    Our Story
                  </Link>
                </li>
              </ul>
            </div>

            {/* Learn */}
            <div className="col">
              <h3 className="text-white fw-normal mb-3 fs-6">Learn</h3>
              <ul className="list-unstyled footer-link-list">
                <li>
                  <Link to={`${WEBSITE_URL}/learn`} className="footer-nav-link">
                    Learn
                  </Link>
                </li>
              </ul>
            </div>

            {/* Doctor Portal */}
            {!token && (
              <div className="col">
                <h3 className="text-white fw-normal mb-3 fs-6">
                  Doctor Portal
                </h3>
                <ul className="list-unstyled footer-link-list">
                  <li>
                    <a
                      href={`${WEBAPP_URL}/?type=dentist`}
                      className="footer-nav-link"
                    >
                      Login/Sign-up
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom-bar mt-5 pt-4">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
            <p className="footer-copyright mb-0">
              © 2026 Asesso. All Rights Reserved.
            </p>
            <div className="d-flex flex-wrap justify-content-center gap-2 gap-md-3 small">
              <a
                href={`${WEBAPP_URL}/about/term_of_service`}
                className="footer-legal-link"
              >
                Terms of Service
              </a>
              <span className="footer-separator">/</span>
              <a
                href={`${WEBAPP_URL}/about/term_of_purchase`}
                className="footer-legal-link"
              >
                Terms of Purchase
              </a>
              <span className="footer-separator">/</span>
              <a
                href={`${WEBAPP_URL}/about/privacy_policy`}
                className="footer-legal-link"
              >
                Privacy Notice
              </a>
              <span className="footer-separator">/</span>
              <a href={`${WEBAPP_URL}/hippa`} className="footer-legal-link">
                Notice of Privacy Practices
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
